import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=dacc28c4"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports